import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';
export function UseCasesPage() {
  const cases = [{
    title: 'OPERATIONAL PERFORMANCE',
    description: 'Measure dwell drivers at stop level, identify root causes of delay and improve timetable reliability, supporting evidence-based performance management.'
  }, {
    title: 'SERVICE AND DEMAND',
    description: 'Observe real passenger flows to align capacity with demand and optimise load distribution across services'
  }, {
    title: 'SAFETY',
    description: 'Detect behavioural patterns and high-risk locations, prioritise interventions and support measurable safety improvements over time'
  }, {
    title: 'NETWORK PLANNING',
    description: 'Aggregate anonymised trends to support investment decisions, cross-route optimisation and long-term planning based on observed passenger behaviour'
  }];
  return <>
      <PageHero eyebrow="USE CASES" headline="Practical outcomes for operators and authorities" data-id="element-302" />

      <section className="bg-sure-dark w-full py-24 md:py-32" data-id="element-303">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-304">
          <div className="flex flex-col space-y-8" data-id="element-305">
            {cases.map((useCase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: index * 0.1
          }} className="bg-[#1a1a1a] border-l-2 border-sure-accent p-8 md:p-12 w-full" data-id="element-306">
                <h3 className="text-sure-white text-lg md:text-xl font-bold uppercase tracking-widest mb-4" data-id="element-307">
                  {useCase.title}
                </h3>
                <p className="text-sure-gray text-base md:text-lg font-light leading-relaxed max-w-4xl" data-id="element-308">
                  {useCase.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-309" />
    </>;
}